<template>
  <!-- <template v-if="false"> -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <div data-template="template3" class="wrap-template template3">
      <div class="main-handicap">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ sportAllBetLang['ALL_BET.SUBHEADER_CSH'] }}</span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="handicap">
            <div class="handicap-item m-oe os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tacapt"></span>
                      </div>
                      <span class="ellipsis"></span>
                    </div>
                  </div>
                  <!-- <div class="odds yb-number-font">
                    <div class="">
                      <span class="yb-family-odds yb-number-bold match_details"> -->
                        <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1" :mode="'ab'" />
                      <!-- </span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="handicap-item m-oe os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tbcapt"></span>
                      </div>
                      <span class="ellipsis"></span>
                    </div>
                  </div>
                  <!-- <div class="odds yb-number-font">
                    <div class="">
                      <span class="yb-family-odds yb-number-bold match_details"> -->
                        <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="team2" :mode="'ab'" />
                      <!-- </span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    // oddsHeader() {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
    //   }

    //   return retCapt
    // },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-csh.vue